export default __webpack_public_path__ + "static/media/pic-exit-case.b12d88b2.svg";